/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserVoteEntry = /* GraphQL */ `
  mutation CreateUserVoteEntry(
    $input: CreateUserVoteEntryInput!
    $condition: ModelUserVoteEntryConditionInput
  ) {
    createUserVoteEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      vote
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserVoteEntry = /* GraphQL */ `
  mutation UpdateUserVoteEntry(
    $input: UpdateUserVoteEntryInput!
    $condition: ModelUserVoteEntryConditionInput
  ) {
    updateUserVoteEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      vote
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserVoteEntry = /* GraphQL */ `
  mutation DeleteUserVoteEntry(
    $input: DeleteUserVoteEntryInput!
    $condition: ModelUserVoteEntryConditionInput
  ) {
    deleteUserVoteEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      vote
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUserFlagEntry = /* GraphQL */ `
  mutation CreateUserFlagEntry(
    $input: CreateUserFlagEntryInput!
    $condition: ModelUserFlagEntryConditionInput
  ) {
    createUserFlagEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserFlagEntry = /* GraphQL */ `
  mutation UpdateUserFlagEntry(
    $input: UpdateUserFlagEntryInput!
    $condition: ModelUserFlagEntryConditionInput
  ) {
    updateUserFlagEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserFlagEntry = /* GraphQL */ `
  mutation DeleteUserFlagEntry(
    $input: DeleteUserFlagEntryInput!
    $condition: ModelUserFlagEntryConditionInput
  ) {
    deleteUserFlagEntry(input: $input, condition: $condition) {
      id
      username
      entry_id
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUserDisclaimerEntry = /* GraphQL */ `
  mutation CreateUserDisclaimerEntry(
    $input: CreateUserDisclaimerEntryInput!
    $condition: ModelUserDisclaimerEntryConditionInput
  ) {
    createUserDisclaimerEntry(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const updateUserDisclaimerEntry = /* GraphQL */ `
  mutation UpdateUserDisclaimerEntry(
    $input: UpdateUserDisclaimerEntryInput!
    $condition: ModelUserDisclaimerEntryConditionInput
  ) {
    updateUserDisclaimerEntry(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserDisclaimerEntry = /* GraphQL */ `
  mutation DeleteUserDisclaimerEntry(
    $input: DeleteUserDisclaimerEntryInput!
    $condition: ModelUserDisclaimerEntryConditionInput
  ) {
    deleteUserDisclaimerEntry(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const createUserFirstVisitEntry = /* GraphQL */ `
  mutation CreateUserFirstVisitEntry(
    $input: CreateUserFirstVisitEntryInput!
    $condition: ModelUserFirstVisitEntryConditionInput
  ) {
    createUserFirstVisitEntry(input: $input, condition: $condition) {
      id
      username
      first_visit
      product_version
      createdAt
      updatedAt
    }
  }
`;
export const updateUserFirstVisitEntry = /* GraphQL */ `
  mutation UpdateUserFirstVisitEntry(
    $input: UpdateUserFirstVisitEntryInput!
    $condition: ModelUserFirstVisitEntryConditionInput
  ) {
    updateUserFirstVisitEntry(input: $input, condition: $condition) {
      id
      username
      first_visit
      product_version
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserFirstVisitEntry = /* GraphQL */ `
  mutation DeleteUserFirstVisitEntry(
    $input: DeleteUserFirstVisitEntryInput!
    $condition: ModelUserFirstVisitEntryConditionInput
  ) {
    deleteUserFirstVisitEntry(input: $input, condition: $condition) {
      id
      username
      first_visit
      product_version
      createdAt
      updatedAt
    }
  }
`;
export const createUserMetadata = /* GraphQL */ `
  mutation CreateUserMetadata(
    $input: CreateUserMetadataInput!
    $condition: ModelUserMetadataConditionInput
  ) {
    createUserMetadata(input: $input, condition: $condition) {
      id
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const updateUserMetadata = /* GraphQL */ `
  mutation UpdateUserMetadata(
    $input: UpdateUserMetadataInput!
    $condition: ModelUserMetadataConditionInput
  ) {
    updateUserMetadata(input: $input, condition: $condition) {
      id
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserMetadata = /* GraphQL */ `
  mutation DeleteUserMetadata(
    $input: DeleteUserMetadataInput!
    $condition: ModelUserMetadataConditionInput
  ) {
    deleteUserMetadata(input: $input, condition: $condition) {
      id
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const createUserRole = /* GraphQL */ `
  mutation CreateUserRole(
    $input: CreateUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    createUserRole(input: $input, condition: $condition) {
      id
      username
      accessGroups
      role
      projects {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserRole = /* GraphQL */ `
  mutation UpdateUserRole(
    $input: UpdateUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    updateUserRole(input: $input, condition: $condition) {
      id
      username
      accessGroups
      role
      projects {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserRole = /* GraphQL */ `
  mutation DeleteUserRole(
    $input: DeleteUserRoleInput!
    $condition: ModelUserRoleConditionInput
  ) {
    deleteUserRole(input: $input, condition: $condition) {
      id
      username
      accessGroups
      role
      projects {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createUserProject = /* GraphQL */ `
  mutation CreateUserProject(
    $input: CreateUserProjectInput!
    $condition: ModelUserProjectConditionInput
  ) {
    createUserProject(input: $input, condition: $condition) {
      id
      projectID
      userID
      accessGroups
      user {
        id
        username
        accessGroups
        role
        projects {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateUserProject = /* GraphQL */ `
  mutation UpdateUserProject(
    $input: UpdateUserProjectInput!
    $condition: ModelUserProjectConditionInput
  ) {
    updateUserProject(input: $input, condition: $condition) {
      id
      projectID
      userID
      accessGroups
      user {
        id
        username
        accessGroups
        role
        projects {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserProject = /* GraphQL */ `
  mutation DeleteUserProject(
    $input: DeleteUserProjectInput!
    $condition: ModelUserProjectConditionInput
  ) {
    deleteUserProject(input: $input, condition: $condition) {
      id
      projectID
      userID
      accessGroups
      user {
        id
        username
        accessGroups
        role
        projects {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      owner
      name
      description
      projectPreference
      snippets {
        items {
          id
          owner
          accessGroups
          projectID
          hit {
            bucket
            region
            key
          }
          pageNum
          hitIdx
          identityID
          hitHashCode
          description
          query
          mode
          filters
          actionDateStart
          actionDateEnd
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      users {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      owner
      name
      description
      projectPreference
      snippets {
        items {
          id
          owner
          accessGroups
          projectID
          hit {
            bucket
            region
            key
          }
          pageNum
          hitIdx
          identityID
          hitHashCode
          description
          query
          mode
          filters
          actionDateStart
          actionDateEnd
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      users {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      owner
      name
      description
      projectPreference
      snippets {
        items {
          id
          owner
          accessGroups
          projectID
          hit {
            bucket
            region
            key
          }
          pageNum
          hitIdx
          identityID
          hitHashCode
          description
          query
          mode
          filters
          actionDateStart
          actionDateEnd
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      users {
        items {
          id
          projectID
          userID
          accessGroups
          user {
            id
            username
            accessGroups
            role
            projects {
              nextToken
            }
            createdAt
            updatedAt
          }
          project {
            id
            owner
            name
            description
            projectPreference
            snippets {
              nextToken
            }
            users {
              nextToken
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createSearchResults = /* GraphQL */ `
  mutation CreateSearchResults(
    $input: CreateSearchResultsInput!
    $condition: ModelSearchResultsConditionInput
  ) {
    createSearchResults(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      title
      description
      filters
      offset
      query
      mode
      actionDateStart
      actionDateEnd
      prevNumPages
      createdAt
      updatedAt
    }
  }
`;
export const updateSearchResults = /* GraphQL */ `
  mutation UpdateSearchResults(
    $input: UpdateSearchResultsInput!
    $condition: ModelSearchResultsConditionInput
  ) {
    updateSearchResults(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      title
      description
      filters
      offset
      query
      mode
      actionDateStart
      actionDateEnd
      prevNumPages
      createdAt
      updatedAt
    }
  }
`;
export const deleteSearchResults = /* GraphQL */ `
  mutation DeleteSearchResults(
    $input: DeleteSearchResultsInput!
    $condition: ModelSearchResultsConditionInput
  ) {
    deleteSearchResults(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      title
      description
      filters
      offset
      query
      mode
      actionDateStart
      actionDateEnd
      prevNumPages
      createdAt
      updatedAt
    }
  }
`;
export const createSnippet = /* GraphQL */ `
  mutation CreateSnippet(
    $input: CreateSnippetInput!
    $condition: ModelSnippetConditionInput
  ) {
    createSnippet(input: $input, condition: $condition) {
      id
      owner
      accessGroups
      projectID
      hit {
        bucket
        region
        key
      }
      pageNum
      hitIdx
      identityID
      hitHashCode
      description
      query
      mode
      filters
      actionDateStart
      actionDateEnd
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSnippet = /* GraphQL */ `
  mutation UpdateSnippet(
    $input: UpdateSnippetInput!
    $condition: ModelSnippetConditionInput
  ) {
    updateSnippet(input: $input, condition: $condition) {
      id
      owner
      accessGroups
      projectID
      hit {
        bucket
        region
        key
      }
      pageNum
      hitIdx
      identityID
      hitHashCode
      description
      query
      mode
      filters
      actionDateStart
      actionDateEnd
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSnippet = /* GraphQL */ `
  mutation DeleteSnippet(
    $input: DeleteSnippetInput!
    $condition: ModelSnippetConditionInput
  ) {
    deleteSnippet(input: $input, condition: $condition) {
      id
      owner
      accessGroups
      projectID
      hit {
        bucket
        region
        key
      }
      pageNum
      hitIdx
      identityID
      hitHashCode
      description
      query
      mode
      filters
      actionDateStart
      actionDateEnd
      project {
        id
        owner
        name
        description
        projectPreference
        snippets {
          items {
            id
            owner
            accessGroups
            projectID
            hit {
              bucket
              region
              key
            }
            pageNum
            hitIdx
            identityID
            hitHashCode
            description
            query
            mode
            filters
            actionDateStart
            actionDateEnd
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        users {
          items {
            id
            projectID
            userID
            accessGroups
            user {
              id
              username
              accessGroups
              role
              createdAt
              updatedAt
            }
            project {
              id
              owner
              name
              description
              projectPreference
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createSearch = /* GraphQL */ `
  mutation CreateSearch(
    $input: CreateSearchInput!
    $condition: ModelSearchConditionInput
  ) {
    createSearch(input: $input, condition: $condition) {
      id
      projectID
      description
      filter
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateSearch = /* GraphQL */ `
  mutation UpdateSearch(
    $input: UpdateSearchInput!
    $condition: ModelSearchConditionInput
  ) {
    updateSearch(input: $input, condition: $condition) {
      id
      projectID
      description
      filter
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteSearch = /* GraphQL */ `
  mutation DeleteSearch(
    $input: DeleteSearchInput!
    $condition: ModelSearchConditionInput
  ) {
    deleteSearch(input: $input, condition: $condition) {
      id
      projectID
      description
      filter
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUserTable = /* GraphQL */ `
  mutation CreateUserTable(
    $input: CreateUserTableInput!
    $condition: ModelUserTableConditionInput
  ) {
    createUserTable(input: $input, condition: $condition) {
      id
      tables
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateUserTable = /* GraphQL */ `
  mutation UpdateUserTable(
    $input: UpdateUserTableInput!
    $condition: ModelUserTableConditionInput
  ) {
    updateUserTable(input: $input, condition: $condition) {
      id
      tables
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteUserTable = /* GraphQL */ `
  mutation DeleteUserTable(
    $input: DeleteUserTableInput!
    $condition: ModelUserTableConditionInput
  ) {
    deleteUserTable(input: $input, condition: $condition) {
      id
      tables
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUserAnnotations = /* GraphQL */ `
  mutation CreateUserAnnotations(
    $input: CreateUserAnnotationsInput!
    $condition: ModelUserAnnotationsConditionInput
  ) {
    createUserAnnotations(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      documentID
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const updateUserAnnotations = /* GraphQL */ `
  mutation UpdateUserAnnotations(
    $input: UpdateUserAnnotationsInput!
    $condition: ModelUserAnnotationsConditionInput
  ) {
    updateUserAnnotations(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      documentID
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserAnnotations = /* GraphQL */ `
  mutation DeleteUserAnnotations(
    $input: DeleteUserAnnotationsInput!
    $condition: ModelUserAnnotationsConditionInput
  ) {
    deleteUserAnnotations(input: $input, condition: $condition) {
      id
      accessGroups
      projectID
      documentID
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const createDataExtractionRequest = /* GraphQL */ `
  mutation CreateDataExtractionRequest(
    $input: CreateDataExtractionRequestInput!
    $condition: ModelDataExtractionRequestConditionInput
  ) {
    createDataExtractionRequest(input: $input, condition: $condition) {
      id
      username
      name
      documentID
      status
      type
      additionalComments
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const updateDataExtractionRequest = /* GraphQL */ `
  mutation UpdateDataExtractionRequest(
    $input: UpdateDataExtractionRequestInput!
    $condition: ModelDataExtractionRequestConditionInput
  ) {
    updateDataExtractionRequest(input: $input, condition: $condition) {
      id
      username
      name
      documentID
      status
      type
      additionalComments
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const deleteDataExtractionRequest = /* GraphQL */ `
  mutation DeleteDataExtractionRequest(
    $input: DeleteDataExtractionRequestInput!
    $condition: ModelDataExtractionRequestConditionInput
  ) {
    deleteDataExtractionRequest(input: $input, condition: $condition) {
      id
      username
      name
      documentID
      status
      type
      additionalComments
      annotations
      createdAt
      updatedAt
    }
  }
`;
export const createNotificationPreferences = /* GraphQL */ `
  mutation CreateNotificationPreferences(
    $input: CreateNotificationPreferencesInput!
    $condition: ModelNotificationPreferencesConditionInput
  ) {
    createNotificationPreferences(input: $input, condition: $condition) {
      id
      enabled
      frequency
      createdAt
      updatedAt
    }
  }
`;
export const updateNotificationPreferences = /* GraphQL */ `
  mutation UpdateNotificationPreferences(
    $input: UpdateNotificationPreferencesInput!
    $condition: ModelNotificationPreferencesConditionInput
  ) {
    updateNotificationPreferences(input: $input, condition: $condition) {
      id
      enabled
      frequency
      createdAt
      updatedAt
    }
  }
`;
export const deleteNotificationPreferences = /* GraphQL */ `
  mutation DeleteNotificationPreferences(
    $input: DeleteNotificationPreferencesInput!
    $condition: ModelNotificationPreferencesConditionInput
  ) {
    deleteNotificationPreferences(input: $input, condition: $condition) {
      id
      enabled
      frequency
      createdAt
      updatedAt
    }
  }
`;
export const createUserSwitchNewUI = /* GraphQL */ `
  mutation CreateUserSwitchNewUI(
    $input: CreateUserSwitchNewUIInput!
    $condition: ModelUserSwitchNewUIConditionInput
  ) {
    createUserSwitchNewUI(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const updateUserSwitchNewUI = /* GraphQL */ `
  mutation UpdateUserSwitchNewUI(
    $input: UpdateUserSwitchNewUIInput!
    $condition: ModelUserSwitchNewUIConditionInput
  ) {
    updateUserSwitchNewUI(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
export const deleteUserSwitchNewUI = /* GraphQL */ `
  mutation DeleteUserSwitchNewUI(
    $input: DeleteUserSwitchNewUIInput!
    $condition: ModelUserSwitchNewUIConditionInput
  ) {
    deleteUserSwitchNewUI(input: $input, condition: $condition) {
      id
      accepted
      createdAt
      updatedAt
    }
  }
`;
